import { useEffect } from 'react';

import { TrackableProperties } from '@lightspeed-payments/payments-portal-sdk';
import { hasCapitalRights } from 'pages/views/payments/lightspeed-capital/utils/hasCapitalRights';

import { getMerchantDetails } from './getMerchantDetails';
import { useTracking } from './TrackingContext';

export function TrackingIdentify(): JSX.Element | null {
  const { identify } = useTracking();
  const { pli, merchantName, userId, accountId, pui, roleName } = getMerchantDetails();

  useEffect(() => {
    if (!pui) return;
    const identifyProps: TrackableProperties = {
      merchant_name: merchantName,
      pli,
      user_id: userId,
      product_id: 'r-series',
      surface: 'r-series',
      merchant_id: accountId,
      role_name: roleName,
      has_capital_rights: hasCapitalRights(),
    };
    identify(pui, identifyProps);
    // pui/pli changes warrant a re-identify (merchant or shop scope changed);
    // other identify props are session-stable and re-firing on every render
    // would duplicate Segment traffic.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pui, pli]);

  return null;
}

export default TrackingIdentify;
